import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ExcelWidgetComponent } from './excel-widget.component';

const routes: Routes = [
  { path: 'excel-widget', component: ExcelWidgetComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExcelWidgetRoutingModule { }
